<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :saveIsDisabled="!required.filled"
    :active-tab="activeTab"
    :action-type="actionType"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <input-field
          v-for="field in visibleTabs[activeTab].fields"
          :key="visibleTabs[activeTab].code + field.label + field.order"
          ref="formInputField"
          :value="getValueInObject(field.var_name, field.input_type)"
          @input="setValueInObject(field.var_name, $event, field.input_type)"
          :label="field.label_client ? field.label_client : field.label"
          :variable-name="field.var_name"
          :inputType="field.input_type"
          :size="field.size"
          :required="field.required"
          :required-filled="required.filled"
          :selectOptions="field.select_list_name"
          :radioOptions="field.radio_options"
          :fieldDisabled="field.disable"
          :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
          :formDisabled="readOnly"
          :hide="field.hide"
          :automatic-label="field.has_automatic_label"
          @generateLabel="getAutomaticLabel(autoLabelRequestData)"
          :checkboxOptions="field.checkbox_options"
          :object-data="objectData"
          :labelIsLocked="objectData.sl_label_locked"
          :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
          @toggle-label-lock="changeLabelMode"
          @updateCheckboxValue="updateCheckboxValue($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>
      <custom-fields-tab
        v-if="visibleTabs[activeTab].code === 'custom_fields'"
        :customFields="customFields.custom_fields"
        :objectData="objectData.custom_fields"
        :actionType="actionType"
        :disabled="readOnly"
        @updateValue="setValueInObject"
        :requiredFilled="required.filled"
      />
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import InputField from "../_Molecules/InputField";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import { bus } from "@/main";
import CustomFieldsTab from "@/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "SlackForm",

  components: {
    DynamicObjectFormStructure,
    InputField,
    CustomFieldsTab
  },

  mixins: [dynamicObjectFormsMixin,checkPermissionsMixin],

  props: {
    slackData: {
      type: Object
    }
  },

  data() {
    return {
      dialog: false
    };
  },

  watch: {
    loadingStructure(newValue) {
      if (!newValue) {
        this.objectData.coordinate_x = this.xCoordinate;
        this.objectData.coordinate_y = this.yCoordinate;
        this.getPreviousImages();
        if (this.actionType === "create")
          this.objectData.cable = this.dataReceived;
      }
    }
  },

  methods: {
    createObject() {
      this.createDataToSend();

      this.CREATE_OBJECTS({
        endpoint: this.form.endpoint,
        data: [this.dataToSend]
      })
        .then(() => {
          this.finishObjectCreation();
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
          this.loadingSave = false;
        });
    },

    createDataToSend() {
      this.dataToSend = {
        node: { text_geom: this.wkt, projection: 3857 },
        cable: { uuid: this.slackData.cableUUID }
      };

      if (this.slackData.nodeObject) {
        this.dataToSend.node_object = this.slackData.nodeObject;
      }

      this.placeObjectDataInDataToSend();
    },

    closeForm() {
      this.loadingSave = false;
      bus.$emit("enable-click-events");
      bus.$emit("reset-slack-data");
      this.$emit("close");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/SlackForm.vue